import { SxProps, Theme } from '@mui/system';

const styles = {
  total: {
    fontWeight: 700,
    fontSize: 17,
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
